import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';

import { OnboardingPageComponent } from './onboarding-page/onboarding-page.component';
import { SigninComponent } from './signin/signin.component';
// import { RiderListComponent } from './rider-list/rider-list.component';
import { SearchRiderComponent } from './search-rider/search-rider.component';
import { ModelSelectionComponent } from './model-selection/model-selection.component';
import { SearchMerchantComponent } from './onboarding-merchant/search-merchant/search-merchant.component';
import { OnboardingMerchantComponent } from './onboarding-merchant/onboarding-merchant.component';
import { RiderLogsComponent } from './rider-logs/rider-logs.component';
import { OnboardingFleetComponent } from './onboarding-fleet/onboarding-fleet.component';
import { SearchFleetComponent } from './onboarding-fleet/search-fleet/search-fleet.component';
import { VehicleFleetComponent } from './onboarding-fleet/vehicle-fleet/vehicle-fleet.component';
import { VehicleModelsComponent } from './vehicle-models/vehicle-models.component';
import { VehicleModelEditComponent } from './vehicle-models/vehicle-model-edit.component';
import { VehicleModelCreateComponent } from './vehicle-models/vehicle-model-create.component';

import { FleetOnboardingComponent } from './onboarding-fleet/fleet-onboarding/fleet-onboarding.component';
import { FleetOnboardingStartComponent } from './onboarding-fleet/fleet-onboarding-start/fleet-onboarding-start.component';
import { FleetOnboardingDetailsComponent } from './onboarding-fleet/fleet-onboarding-details/fleet-onboarding-details.component';
import { FleetManagerOnboardingComponent } from './onboarding-fleet/fleet-manager-onboarding/fleet-manager-onboarding.component';
import { FleetManagerOnboardingDetailsComponent } from './onboarding-fleet/fleet-manager-onboarding-details/fleet-manager-onboarding-details.component';
import { PartnerOnboardingComponent } from './partner-onboarding/partner-onboarding.component';
import { HostSearchComponent } from './host/host-search.component';
import { HostDetailComponent } from './host/host-detail.component';
import { HostRcResultsComponent } from './host/host-rc-results.component';
import { HostVehicleModelCreateComponent } from './host/host-vehicle-model-create.component';


const appRoutes: Routes = [
  {
    path: 'onboarding',
    component: OnboardingPageComponent
  },
  {
    path: 'vehicle-models',
    component: VehicleModelsComponent
  },
  {
    path: 'vehicle-models/create',
    component: VehicleModelCreateComponent
  },
  {
    path: 'vehicle-models/:id/edit',
    component: VehicleModelEditComponent
  },
  {
    path: '',
    component: SigninComponent
  },
  // {
  //   path: 'riders',
  //   component: RiderListComponent
  // },
  {
    path: 'search',
    component: SearchRiderComponent
  },
  {
    path: 'modelSelection',
    component: ModelSelectionComponent
  },
  {
    path: 'searchMerchant',
    component: SearchMerchantComponent
  },
  {
    path: 'onboardFleet',
    component: OnboardingFleetComponent
  },
  {
    path: 'searchFleet',
    component: SearchFleetComponent
  },
  {
    path: 'fleetVehicleList',
    component: VehicleFleetComponent
  },
  {
    path: 'onboardingMerchant',
    component: OnboardingMerchantComponent
  },
  {
    path: 'riderLogs/:riderId',
    component: RiderLogsComponent
  },
  {
    path: 'fleetOnboarding',
    component: FleetOnboardingComponent
  },
  {
    path: 'fleetOnboardingStart',
    component: FleetOnboardingStartComponent
  },
  {
    path: 'fleetOnboardingDetails',
    component: FleetOnboardingDetailsComponent
  }
  ,
  {
    path: 'fleetManagerOnboarding',
    component: FleetManagerOnboardingComponent
  }
  ,
  {
    path: 'fleetManagerOnboardingDetails',
    component: FleetManagerOnboardingDetailsComponent
  }
  ,
  {
    path: 'partnerOnboarding',
    component: PartnerOnboardingComponent
  },
  {
    path: 'hostSearch',
    component: HostSearchComponent
  },
  {
    path: 'host/rc-results',
    component: HostRcResultsComponent
  },
  {
    path: 'host/vehicle-model/create',
    component: HostVehicleModelCreateComponent
  },
  {
    path: 'host/:hostId',
    component: HostDetailComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false, // <-- debugging purposes only
        preloadingStrategy: SelectivePreloadingStrategy,

      }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }
